var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47658 9.10516H2.68718C1.99245 9.10516 1.5293 8.64201 1.5293 7.94728V2.15788C1.5293 1.46315 1.99245 1 2.68718 1C3.38191 1 3.84506 1.46315 3.84506 2.15788V6.7894H8.47658C9.17131 6.7894 9.63446 7.25255 9.63446 7.94728C9.63446 8.64201 9.17131 9.10516 8.47658 9.10516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7922 23.0003C9.51849 23.0003 8.24482 22.7687 7.08694 22.3056C5.00276 21.4951 3.26594 20.1056 1.99227 18.253C1.6449 17.6741 1.76069 16.9793 2.33963 16.632C2.91857 16.2846 3.6133 16.4004 3.96066 16.9793C4.88697 18.3688 6.27642 19.5267 7.89746 20.1056C9.51849 20.6846 11.2553 20.8004 12.9921 20.3372C14.6132 19.874 16.1184 18.832 17.1605 17.4425C18.2026 16.053 18.7815 14.432 18.8973 12.6952C18.8973 10.9584 18.4342 9.22155 17.3921 7.83209C16.35 6.44264 14.9605 5.40054 13.3395 4.8216C11.7185 4.24266 9.98164 4.24266 8.24482 4.8216C6.62379 5.40054 5.23433 6.44264 4.19224 7.83209C3.84488 8.41103 3.15015 8.52682 2.57121 8.17946C1.99227 7.83209 1.87648 7.02158 2.33963 6.55842C3.6133 4.70582 5.46591 3.31636 7.55009 2.62163C9.63428 1.9269 11.95 1.9269 14.0342 2.62163C16.1184 3.31636 17.971 4.70582 19.2447 6.55842C20.5184 8.41103 21.2131 10.4952 21.0973 12.811C21.0973 15.0109 20.2868 17.2109 18.8973 18.9477C17.5079 20.6846 15.6553 21.9582 13.4553 22.653C12.7606 22.8845 11.7185 23.0003 10.7922 23.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.9dea9e2808dc05eee5a1c8eaddf22367.svg";
export { ForwardRef as ReactComponent };